import VueBarrel from '../../components/community/img_flex/VueBarrel.vue';

const vueBarrel = {

  install (Vue, options) {

    if (typeof window !== 'undefined' && window.Vue) {
      Vue = window.Vue
    }
    Vue.component(VueBarrel.name, VueBarrel)
  }

}

export default vueBarrel


// WEBPACK FOOTER //
// ./src/assets/js/VueBarrel.js